module.exports = __webpack_public_path__ + "static/media/zamygo_partner_fresh-diversion.637bede9.png";